import { Box, Text } from '@factorialco/deprecated-design-system'
import { F0Icon } from '@factorialco/f0-react'
import { Money } from '@factorialco/f0-react/icons/app'

import { EmptyStateProps } from 'modules/finance/components/FinancialWorkspace/components/Table/types'

export const EmptyState = ({ icon = Money, title, description }: EmptyStateProps) => {
  return (
    <Box width="full" justifyContent="center" alignItems="center" paddingY="s96" gap="s12">
      <Box
        padding="s8"
        borderRadius={{ all: 'abs008' }}
        border={{ all: { color: 'grey400', width: 's1', style: 'solid' } }}
      >
        <F0Icon color="secondary" icon={icon} size="lg" />
      </Box>
      <Box justifyContent="center" alignItems="center">
        <Text.Normal weight="medium" color="grey1000" size="400">
          {title}
        </Text.Normal>
        <Text.Normal>{description}</Text.Normal>
      </Box>
    </Box>
  )
}
